import { LAUNCH_APP_COMMON_PARAMS_KEY, } from './constants';
const getCurrentPageParams = (urlParams) => {
    const { prod_key, dchn, oaid, oaid_md5, imei, imei_md5, idfa, idfa_md5, product_id, scene, can_open_np } = urlParams;
    const currentPageParams = {
        current_page_prod_key: prod_key,
        current_page_dchn: dchn,
        oaid,
        oaid_md5,
        imei,
        imei_md5,
        idfa,
        idfa_md5,
        product_id,
        scene,
        can_open_np,
    };
    return currentPageParams;
};
const getLaunchAppCommonParams = (urlParams) => {
    const params = {};
    LAUNCH_APP_COMMON_PARAMS_KEY.forEach(key => {
        params[key] = urlParams[key] || '';
    });
    return params;
};
export { getCurrentPageParams, getLaunchAppCommonParams };
